import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';
import Order from '../../../smoothr-web-app-core/models/Order';
import {OrderUtils} from '../../../smoothr-web-app-core/utils/order-utils';
import {environment} from '../../../environments/environment';
import {numberToCurrency} from 'src/smoothr-web-app-core/utils/utils';
import {NavigationService} from 'src/app/services/navigation.service';
import SubscriptionArticles from 'src/smoothr-web-app-core/models/Subscription';

@Component({
	selector: 'app-to-order-button',
	templateUrl: './to-order-button.component.html',
	styleUrls: ['to-order-button.component.scss']
})
export class ToOrderButtonComponent {
	@Input() order: Order;
	@Input() subscriptionUser: SubscriptionArticles[];

	constructor(
		private router: Router,
		private navigationService: NavigationService
	) {}

	get price(): number {
		if (!this.order) {
			return 0;
		}
		const orderArticles = this.order.orderedArticles.concat(...(this.order.orderedSubscriptionArticles ?? []));
		return OrderUtils.articleGroupsWithSubscriptionTotalPrice(
			orderArticles,
			[],
			this.order.subscriptions,
			this.order.type,
			this.order.preorder.type,
			this.order.terminalorder ? this.order.terminalorder.type : null,
			(this.order.subscriptions ?? []).concat(this.subscriptionUser)
		);
	}

	get formattedPrice(): string {
		return numberToCurrency(this.price, this.order.currency);
	}

	get active(): boolean {
		return (
			this.order.orderedArticles.length > 0 ||
			this.order.orderedSubscriptionArticles.length > 0 ||
			this.order.subscriptions.length > 0
		);
	}

	async goToOrder() {
		if (this.active) {
			await this.navigationService.order();
		}
	}
}
